module.exports = __webpack_public_path__ + "8698b5e6e89ac33b1b2f600d272dd933.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/netzbuehne02.jpg
// module id = 670
// module chunks = 0